<mat-form-field *ngIf="formGroup && !displayWithProperty" [formGroup]="formGroup" style="width: 100%; display: flex;">
  <mat-label>{{ fieldLabel }}</mat-label>
  <input #autocompleteInput matInput [formControlName]="formControlName" [id]="formControlName"
    [matAutocomplete]="autoGenerico" [placeholder]="placeholder" [readonly]="readonly"
    (blur)="inputBlur.emit($event)" (input)="handleInput($event)" (keyup)="inputKeyup.emit($event)"
    (keydown)="inputKeydown.emit($event)" />

  <button *ngIf="formGroup.get(formControlName)?.value && !formGroup.get(formControlName)?.disabled" mat-icon-button
    matSuffix type="button" (click)="clearInput($event)" tabindex="-1">
    <mat-icon>close</mat-icon>
  </button>

  <button *ngIf="!formGroup.get(formControlName)?.value && !formGroup.get(formControlName)?.disabled" mat-icon-button
    matSuffix type="button" (click)="focusInput()" tabindex="-1">
    <mat-icon>arrow_drop_down</mat-icon>
  </button>

  <mat-autocomplete #autoGenerico="matAutocomplete" (optionSelected)="onSelectOption($event)"
    [displayWith]="displayWith">
    <mat-option *ngFor="let option of filteredOptions$ | async" [value]="option">
      {{ optionLabel(option) }}
    </mat-option>
  </mat-autocomplete>

  <mat-error *ngIf="showErrorMessage && formGroup.controls[formControlName]?.errors?.['required']">{{ placeholder }} é
    Obrigatório</mat-error>
</mat-form-field>


<mat-form-field *ngIf="formGroup && displayWithProperty" [formGroup]="formGroup" fxFlex style="width: 100%; display: flex;">
  <mat-label>{{ fieldLabel }}</mat-label>
  <input #autocompleteInput matInput [formControlName]="formControlName" [id]="formControlName"
    [matAutocomplete]="autoGenerico" [placeholder]="placeholder" [readonly]="readonly"
    (blur)="inputBlur.emit($event)" (input)="handleInput($event)" (keyup)="inputKeyup.emit($event)"
    (keydown)="inputKeydown.emit($event)" />

  <button *ngIf="formGroup.get(formControlName)?.value && !formGroup.get(formControlName)?.disabled" mat-icon-button
    matSuffix type="button" (click)="clearInput($event)" tabindex="-1">
    <mat-icon>close</mat-icon>
  </button>

  <button *ngIf="!formGroup.get(formControlName)?.value && !formGroup.get(formControlName)?.disabled" mat-icon-button
    matSuffix type="button" (click)="focusInput()" tabindex="-1">
    <mat-icon>arrow_drop_down</mat-icon>
  </button>

  <mat-autocomplete #autoGenerico="matAutocomplete" (optionSelected)="onSelectOption($event)"
    [displayWith]="displayWith.bind(this)">
    <mat-option *ngFor="let option of filteredOptions$ | async" [value]="option">
      {{ optionLabel(option) }}
    </mat-option>
  </mat-autocomplete>

  <mat-error *ngIf="showErrorMessage && formGroup.controls[formControlName]?.errors?.['required']">{{ placeholder }} é
    Obrigatório</mat-error>
</mat-form-field>

<mat-form-field *ngIf="!formGroup" style="width: 100%; display: flex;">
  <mat-label>{{ fieldLabel }}</mat-label>
  <input #autocompleteInput matInput [formControl]="standaloneControl" [id]="id || formControlName"
    [matAutocomplete]="autoStandalone" [placeholder]="placeholder" [readonly]="readonly"
    (blur)="inputBlur.emit($event)" (input)="handleInput($event)" (keyup)="inputKeyup.emit($event)"
    (keydown)="inputKeydown.emit($event)" />

  <mat-autocomplete #autoStandalone="matAutocomplete" (optionSelected)="onSelectOption($event)"
    [displayWith]="displayWith">
    <mat-option *ngFor="let option of filteredOptions$ | async" [value]="option">
      {{ optionLabel(option) }}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
